import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'
export const ArrowIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="12"
      height="12"
      viewBox="0 0 18 10"

      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
    >
      <path
        d="M0.666992 4.49965C0.534384 4.49965 0.407207 4.55232 0.313439 4.64609C0.21967 4.73986 0.166992 4.86704 0.166992 4.99965C0.166992 5.13225 0.21967 5.25943 0.313439 5.3532C0.407207 5.44697 0.534384 5.49965 0.666992 5.49965L6.83366 5.49965L6.83366 8.99965C6.83375 9.09847 6.86312 9.19506 6.91806 9.2772C6.97301 9.35934 7.05107 9.42336 7.14238 9.46117C7.23369 9.49898 7.33415 9.50888 7.43108 9.48962C7.52802 9.47037 7.61707 9.42282 7.68699 9.35298L11.687 5.35298C11.7806 5.25923 11.8332 5.13215 11.8332 4.99965C11.8332 4.86715 11.7806 4.74006 11.687 4.64631L7.68699 0.646311C7.61707 0.576474 7.52802 0.528926 7.43108 0.509669C7.33415 0.490412 7.23369 0.500312 7.14238 0.53812C7.05107 0.575928 6.97301 0.639947 6.91806 0.72209C6.86312 0.804234 6.83375 0.900819 6.83366 0.999645L6.83366 4.49965L0.666992 4.49965Z"

      />
    </SvgIcon>
  )
}
